module.exports = __webpack_public_path__ + "media/images/ecalls/03_reasons_market-fb4a4cf82f6772396a870ad8b4d1c5d6.png";